export const DETAILS_SECTION_COPY = {
  title: "Details",
  action: "Edit details",
  termination_date: "Separation date",
  final_work_date: "Last day of work",
  termination_type: "Separation type",
  termination_reason: "Separation reason",
};
